import React, { useEffect, useState } from "react";
import logo from "../../assets/logo.png";
import Popupboxx from "../Popupbox/Popupbox";
import call from "../../assets/projecticons/telephone-call.png";
import whatsapp from "../../assets/projecticons/whatsapp.png";
import "./navbar.css";


function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [ isPopupOpen, setIsPopupOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // cleanup
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const navbarStyle = {
    width: "100%",
    background: scrolled ? "#080c6a" : "transparent", // 🔥 Change on scroll
    padding: "3px 25px",
    boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
    position: "fixed",
    top: 0,
    left: 0,
    zIndex: 999,
    transition: "0.3s ease", // smooth transition
  };

  const containerStyle = {
    maxWidth: "1250px",
    margin: "0 auto",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };

  const logoStyle = {
    width: "90px",
    height: "auto",
  };

  const buttonStyle = {
    padding: "10px 25px",
    background: "#c10000",
    border: "none",
    borderRadius: "6px",
    color: "#fff",
    cursor: "pointer",
    fontSize: "15px",
    fontWeight: 700,
    transition: "0.3s",
  };

  const buttonHover = {
    background: "#fff",
    color: "#080c6a",
    border: "1px solid #38b6ff",
  };

  return (
    <>
    <div style={navbarStyle} className="navbarStyle">
      <div style={containerStyle}>

        {/* LOGO */}
        <img src={logo} alt="Logo" style={logoStyle}  className="logostyle"/>

        {/* BUTTON */}
        <button
          style={buttonStyle} className="buttonstyle"
          onMouseOver={(e) => Object.assign(e.target.style, buttonHover)}
          onMouseOut={(e) => Object.assign(e.target.style, buttonStyle)}
          onClick={() => setIsPopupOpen(true)}
        >
          Enroll Now
        </button>

      </div>
    </div>

    
      <section>
        <div class="main-icons">
          <ul class="first">
            <li class="color1">
              <a href="tel:+916380866249">
                <p>Call 
                  <br/>+91 6380866249</p>
                <img src={call} width="20" height="20" class="img-fluid"
                  alt="Call Icon" />
              </a>
            </li> 
            <li class="color2">
              <a href="https://api.whatsapp.com/send?phone=916380866249" target="_blank">
                <p>Whatsapp 
                  <br/>+91 6380866249</p>
                <img src={whatsapp} width="24" height="24" class="img-fluid"
                  alt="WhatsApp Icon" />
              </a>
            </li>
          
          </ul>
        </div>
      </section>
    <Popupboxx
        isOpen={isPopupOpen}
        onClose={() => setIsPopupOpen(false)}
      />
      </>
  );
}

export default Navbar;
